// ============================================================================
// PORTUGUESE TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "A Unidade que Produz a Paz",
    author: "Por Emmanuel",
    subtitle: "Cada religião tem suas razões, nossas fronteiras vêm do passado",
    description: "Módulo de reflexão sobre a unidade espiritual e a paz entre as tradições",
    
    nav: {
      intro: "Intro",
      religions: "Religiões",
      common: "Bases Comuns",
      humility: "Humildade"
    },

    intro: {
      emmanuelSays: "Emmanuel diz:",
      ourBordersFromPast: "Nossas fronteiras vêm do passado",
      bordersDescription: "Cada religião tem suas razões. Nossas divisões não são a vontade divina, mas o fruto da história, da geografia, da cultura.",
      divisionWork: "A divisão, o isolamento através de barreiras e fronteiras de medo, é a obra do nosso passado perigoso.",
      sharedHumanity: "Nascemos em tradições diferentes, mas compartilhamos a mesma humanidade.",
      
      revelationTitle: "Uma revelação que abre os olhos",
      surprisedLearning: "Fiquei surpreso um dia ao descobrir que os Judeus também são filhos de Deus.",
      angelMichael: "Que o anjo Miguel é um grande mensageiro para os muçulmanos.",
      jesusNames: "Que Jesus, Isa, Yeshua são conhecidos de várias maneiras, mesmo na fé cristã.",
      diverseTribes: "Porque existem diversas tribos, diversas igrejas, diversas famílias.",
      sameRealities: "Falamos das mesmas realidades com nomes diferentes. Isso deveria nos aproximar, não nos dividir.",
      
      respectTitle: "O respeito: base da humildade, guardião da paz",
      respectFoundation: "Mesmo que a fraternidade não seja objetivamente aplicável, o respeito é a base da humildade, guardião da paz.",
      understandingProcess: "Compreender e respeitar as outras religiões é um processo de humildade. Isso não significa renunciar à sua fé, mas aceitar que o outro também busca a verdade.",
      
      whatBindsUs: "O que realmente nos une",
      seekingRelation: "Cada religião busca o relacionamento. Cada homem busca a paz.",
      loveOfGod: "Este relacionamento que nos une a todos é o amor de Deus.",
      universalLink: "O amor é o vínculo universal que transcende todas as fronteiras, todas as línguas, todas as tradições.",
      
      inclusionTitle: "A inclusão: ainda mais vasta que a diversidade religiosa",
      vastInclusion: "A diversidade religiosa é vasta, mas ainda mais vasta é a inclusão dos outros onde são chamados por Deus.",
      respectDifferences: "O respeito às diferenças de cor, de gênero, a inclusão nos torna humanos únicos, amados por Deus.",
      jesusCommand: "Jesus disse: 'Amai-vos uns aos outros.'",
      
      communitySpirit: "Romper com o espírito comunitarista",
      communityTerror: "O comunitarismo é o terror do ódio do mal disfarçado. Ele transforma a fé em identidade tribal, em muro que separa, em arma que fere.",
      pridePolitics: "Nossos espíritos partidários nos empurram para a política do orgulho:",
      prideQuotes: "Tenho razão em te machucar. Tenho razão e pronto. Tenho razão em fazer guerra justa.",
      watchHeart: "Prestem atenção ao coração do problema, à raiz do nosso próprio mal.",
      refuseDivision: "Recusemos essa deriva que divide a humanidade em nome de Deus.",
      
      freedomTitle: "Para ser livre, tornar os outros livres",
      freedomOthers: "Para ser livre, é preciso saber tornar os outros livres também.",
      defendFreedom: "Minha liberdade de crer só tem valor se eu defendo a de todos. Oprimir o outro é me condenar à servidão.",
      
      changeHeartTitle: "Muda teu coração: sê uma verdadeira lanterna",
      recognizeDecency: "Reconhecer que a decência não é a mesma para cada um.",
      changeYourself: "Mudança de ti primeiro, progressivamente. Muda teu coração, transforma tua vida, sê uma verdadeira lanterna.",
      beExample: "Não farás xixi no gramado, porque ele perecerá... Não impor suas regras aos outros, mas tornar-se um exemplo vivo através de sua transformação.",
      
      childrenPeaceTitle: "Nossos filhos viverão em paz na diversidade",
      avoidPursuit: "Evitar a perseguição de palavras por palavras.",
      peaceChoice: "Se escolhermos o respeito hoje, nossos filhos do futuro viverão em paz na diversidade. A paz começa por nós, agora, em nossas palavras e ações.",
      
      discernTitle: "Discernir: o homem ou Deus?",
      manSpeaks: "Muitas vezes é o coração do homem que fala e divide.",
      seeFruits: "Vemos isso pelos frutos das palavras: o roubo, a destruição, as guerras. Cuidado com a manipulação das palavras para concorrer ao próprio orgulho.",
      
      lookPeaceTitle: "Olhar para a paz e para o amor",
      lookPeaceAll: "Olhar para a paz para todos, olhar para o amor de Deus pelos outros.",
      godSpeaks: "Quando as palavras produzem paz, reconciliação, unidade: é Deus quem fala. Quando produzem divisão, ódio, guerra: é o orgulho do homem.",
      
      watchWordsTitle: "Vigiar nossas palavras",
      watchShares: "Vigiar nossas partilhas, vigiar nossas palavras contrárias nefastas aos outros.",
      disqualify: "Esses males nos desqualificam. Os frutos de nossas palavras revelam quem fala em nós: Deus ou nosso próprio orgulho?",
      
      wisdomMaturityTitle: "Sabedoria e maturidade diante de nossa natureza",
      useScriptures: "Usar as escrituras (as leis) para fazer mal é nosso hábito, um processo quase natural e malicioso.",
      hateSin: "Diante de nossa natureza pecadora, temos horror ao mal e às pessoas que fazem o mal.",
      separateActs: "Mas por sabedoria e maturidade, é preciso separar os atos de nossa pobreza humana.",
      compassionNature: "Reconhecer nossa natureza animal que precisa de compaixão e graça, protegendo-se conforme os contextos.",
      
      denounceLeadersTitle: "Denunciar os líderes espirituais corruptos",
      watchLeaders: "Cuidado com os líderes espirituais ou dirigentes que buscam manter em segredo seu declínio e desonestidade.",
      noJustice: "Sem justiça, sem exemplo. Sem conhecimento, outras vítimas perecem por nosso silêncio.",
      silenceComplicity: "O silêncio diante da injustiça é cumplicidade. A verdade deve ser dita para proteger os outros."
    },

    religions: {
      title: "Diversas Religiões, uma Humanidade",
      intro: "Cristãos, Muçulmanos, Judeus, Hindus, Budistas... e muitos outros: todos buscam a verdade",
      theirGod: "Seu Deus:",
      theGood: "O Bem:",
      theEvil: "O Mal:",
      theAngels: "Os Anjos:",
      theUnity: "A Unidade:",
      values: "Valores:",
    commonGoal: "Objetivo Comum",
    seekingPeace: "Todas as religiões compartilham um objetivo comum: buscar a paz, promover o amor e construir um mundo melhor. Além de nossas diferenças, todos estamos unidos nesta busca por sabedoria e harmonia.",
      
      christianity: {
        name: "Cristianismo",
        godText: "Um Deus único, Pai criador",
        goodText: "O amor ao próximo, o perdão, a paz",
        evilText: "O ódio, o egoísmo, a violência",
        angelsText: "Os mensageiros de Deus (Gabriel, Miguel...)",
        unityText: "Um só Deus para todos os homens",
        values: "Amor,Perdão,Paz,Humildade,Justiça"
      },
      islam: {
        name: "Islã",
        godText: "Allah, o Único e Misericordioso",
        goodText: "A justiça, a caridade, a paz",
        evilText: "A opressão, a mentira, a divisão",
        angelsText: "Os anjos de luz (Jibril, Mikail...)",
        unityText: "Não há deus senão Allah",
        values: "Paz,Justiça,Caridade,Respeito,Misericórdia"
      },
      judaism: {
        name: "Judaísmo",
        godText: "YHWH, o Eterno único",
        goodText: "A justiça, a compaixão, a vida",
        evilText: "A opressão, a maledicência, o ódio",
        angelsText: "Os mensageiros celestes (Malakhim)",
        unityText: "Ouve Israel, o Eterno é Um",
        values: "Justiça,Vida,Memória,Paz,Estudo"
      },
      hinduism: {
        name: "Hinduísmo",
        godText: "Brahman, a realidade suprema",
        goodText: "A não-violência (ahimsa), o dever justo",
        evilText: "A violência, a ignorância espiritual",
        angelsText: "Os Devas, seres celestes benevolentes",
        unityText: "Tudo é Um em Brahman",
        values: "Não-violência,Verdade,Compaixão,Pureza,Harmonia"
      },
      buddhism: {
        name: "Budismo",
        godText: "Nenhum deus criador, mas respeito ao sagrado",
        goodText: "A compaixão, a sabedoria, a paz",
        evilText: "O sofrimento causado pela ignorância",
        angelsText: "Os Bodhisattvas, seres iluminados",
        unityText: "Natureza de Buda em cada um",
        values: "Compaixão,Sabedoria,Paz,Não-violência,Despertar"
      }
    },

    common: {
      title: "As Bases Comuns",
      intro: "O Bem, o Mal, os Anjos, Um Deus Único, o Relacionamento, a Inclusão: o que une a humanidade",
      
      goodTitle: "O Bem",
      goodDescription: "Todas as religiões ensinam o amor, a justiça e a compaixão",
      goodExamples: "Amar o próximo como a si mesmo|Fazer o bem sem distinção|Proteger os fracos e oprimidos|Dizer a verdade com bondade|Compartilhar o que se tem",
      
      evilTitle: "O Mal",
      evilDescription: "Todas condenam a violência, a mentira e a opressão",
      evilExamples: "Matar sem justiça|Roubar e explorar|Mentir e caluniar|Desprezar e humilhar|Dividir e odiar",
      
      angelsTitle: "Os Anjos e Seres Espirituais",
      angelsDescription: "Quase todas reconhecem mensageiros celestes benevolentes",
      angelsExamples: "Anjos mensageiros de Deus|Guias espirituais|Seres de luz|Protetores celestes|Bodhisattvas e Devas",
      
      godTitle: "Um Deus Único (ou Realidade Suprema)",
      godDescription: "A maioria acredita em uma fonte única, um criador ou uma realidade última",
      godExamples: "Cristianismo, Islã, Judaísmo: Um só Deus|Hinduísmo: Brahman, o Uno supremo|Budismo: Natureza de Buda universal|Todos buscam a verdade última|Todos aspiram à unidade e à paz",
      
      relationTitle: "O Relacionamento e a Paz",
      relationDescription: "O que realmente une todas as religiões e todos os homens",
      relationExamples: "Cada religião busca o relacionamento com o divino|Cada homem busca a paz|Este relacionamento que nos une a todos é o amor de Deus|O amor é o vínculo universal|A paz é nossa aspiração comum",
      
      inclusionTitle: "A Inclusão: Amados por Deus",
      inclusionDescription: "A diversidade religiosa é vasta, mas ainda mais vasta é a inclusão",
      inclusionExamples: "Inclusão dos outros onde são chamados por Deus|Respeito às diferenças de cor|Respeito às diferenças de gênero|A inclusão nos torna humanos únicos, amados por Deus|Jesus disse: 'Amai-vos uns aos outros'",
      
      finalQuote: "Fiquei surpreso um dia ao descobrir que os Judeus também são filhos de Deus, que o anjo Miguel é um grande mensageiro para os muçulmanos, que Jesus, Isa, Yeshua são conhecidos de várias maneiras mesmo na fé cristã. Porque existem diversas tribos, diversas igrejas, diversas famílias.",
      finalQuote2: "Falamos das mesmas realidades com nomes diferentes.",
      quoteAuthor: "Emmanuel, A Unidade que Produz a Paz"
    },

    humility: {
      title: "7 Etapas rumo à Humildade e à Paz",
      intro: "O processo para superar o comunitarismo e tornar-se uma verdadeira lanterna",
      
      step: "Etapa",
      action: "Ação:",
      
      step1Title: "Reconhecer: nossas fronteiras vêm do passado",
      step1Description: "A divisão, o isolamento através de barreiras e fronteiras de medo, é a obra do nosso passado perigoso. Nossas divisões não são a vontade de Deus.",
      step1Action: "Aceitar que minha tradição é apenas minha, e faço parte da diversidade querida por Deus",
      
      step2Title: "O respeito: base da humildade, guardião da paz",
      step2Description: "Mesmo que a fraternidade não seja objetivamente aplicável, o respeito é o fundamento.",
      step2Action: "Respeitar todas as crenças, mesmo sem entender tudo",
      
      step3Title: "Compreender sem julgar",
      step3Description: "Hoje, compreender os outros é um processo de humildade necessário.",
      step3Action: "Ouvir verdadeiramente o que os outros acreditam, sem julgamento",
      
      step4Title: "Mudança de ti primeiro: sê uma verdadeira lanterna",
      step4Description: "Reconhecer que a decência não é a mesma para cada um. Muda teu coração progressivamente, transforma tua vida, torna-te uma verdadeira luz.",
      step4Action: "Não impor minhas regras aos outros, mas ser um exemplo vivo através de minha transformação",
      
      step5Title: "Romper com o espírito comunitarista",
      step5Description: "Nossos espíritos partidários nos empurram para a política do orgulho: 'Tenho razão em te machucar, tenho razão e pronto.' Prestem atenção ao coração do problema, à raiz do nosso próprio mal.",
      step5Action: "Recusar os discursos de divisão em minha própria comunidade",
      
      step6Title: "Para ser livre, tornar os outros livres",
      step6Description: "Minha liberdade depende daquela que concedo aos outros.",
      step6Action: "Defender a liberdade de consciência de todos, não apenas a minha",
      
      step7Title: "Evitar a perseguição de palavras por palavras",
      step7Description: "Não responder ao ódio com ódio, aos insultos com insultos.",
      step7Action: "Escolher a paz para que nossos filhos vivam em paz na diversidade",
      
      discernFruits: "Discernir pelos Frutos",
      humanHeart: "O coração do homem que divide",
      lookGodLove: "Olhar para o amor de Deus",
      watchOurWords: "Vigiar nossas Palavras",
      
      prideFruits: "Frutos do orgulho humano",
      prideFruitsList: "Espírito de partido: \"Eu estou certo, ponto\"|Política do orgulho: \"Eu tenho razão de te machucar\"|Usar as escrituras para machucar (processo travesso)|Odiar as pessoas (não apenas os atos)|Líderes espirituais que escondem seu desvio e desonestidade|Silêncio cúmplice diante da injustiça|Divisão e guerras|Ódio disfarçado de piedade|Roubo e destruição|Manipulação por orgulho|Desprezo e violência",
      
      godFruits: "Frutos do amor de Deus",
      godFruitsList: "Separar os atos da pessoa com sabedoria|Compaixão por nossa pobreza humana|Graça enquanto nos protegemos segundo os contextos|Denunciar a injustiça para proteger os outros|Dizer a verdade com coragem|Paz para todos|Amor sem distinção|Reconciliação e unidade|Humildade e respeito|Liberdade para todos",
      
      finalQuote: "Mesmo que a fraternidade não seja objetivamente aplicável, o respeito é a base da humildade, guardião da paz. Evitar a perseguição de palavras por palavras, e nossos filhos do futuro viverão em paz na diversidade.",
      author: "Emmanuel"
    },

    footer: {
      quote: "O respeito é a base da humildade, guardião da paz. Nossos filhos viverão em paz na diversidade se escolhermos o respeito hoje.",
      author: "Emmanuel, A Unidade que Produz a Paz"
    }
};

export default unityTranslations;
